(function() {
  'use strict';

  /**
   * Reads in a JSON array of rules from the page
   * @private
   */
  window.readEnablingRulesFromPage = function(){
    if ($('#rules_for_enabling_disabling_fields').length) {
      return JSON.parse($('#rules_for_enabling_disabling_fields').text());
    } else{
      throw new Error('No rules found for enabling fields.');
    }
  }

  window.getClosestDataRowIdToEvent = function(event){
    return $(event.target).closest('tr.batch_row').data('rowId');
  }
})();
